Object.defineProperty(exports, '__esModule', { value: true });

var ModalStore = require('./ModalStore.js');

var GlobalStore = /** @class */ (function () {
    function GlobalStore() {
        var _this = this;
        this.getModalStore = function () { return _this.modalStore; };
        this.modalStore = new ModalStore.ModalStore();
    }
    return GlobalStore;
}());

exports.GlobalStore = GlobalStore;
